
import { get as getAuth,put } from "helpers/api_helper/Authentication/authenticationApiHelper"
import * as url from "helpers/url_helper/url_helper"

export const getUserDefinitionByGuid = token => getAuth(url.USER_DEFINITIONS_BY_GUID, { params: { token } })
export const userDefinitionPasswordSendMail = emailAdress => getAuth(url.USER_DEFINITIONS_PASSWORD_SEND_MAIL,  { params: { emailAdress } })
export const updateUserDefinitionNewPassword = userDefinition => put(url.USER_DEFINITIONS_UPDATE_NEW_PASSWORD, userDefinition)

